import styled from "styled-components";
import { Flex } from "@thenounproject/lingo-core";

const ThumbnailWrapper = styled(Flex).attrs<{ aspectRatio?: number; minHeight?: number }>(
  ({ aspectRatio, minHeight }) => {
    return {
      width: "100%",
      height: aspectRatio ? undefined : "100%",
      position: "relative",
      justifyContent: "center",
      borderRadius: "default",
      minHeight: minHeight ?? "60px",
    };
  }
)<{ aspectRatio?: number }>`
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  align-items: center;
  & img {
    position: static;
    transform: none;
    max-width: 100%;
    height: auto;
    display: block;
  }
`;
export default ThumbnailWrapper;
